import { render, staticRenderFns } from "./country-state-component.vue?vue&type=template&id=543c0675&scoped=true&"
import script from "./country-state-component.vue?vue&type=script&lang=tsx&"
export * from "./country-state-component.vue?vue&type=script&lang=tsx&"
import style0 from "./country-state-component.vue?vue&type=style&index=0&id=543c0675&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c0675",
  null
  
)

export default component.exports